export default "__VITE_ASSET__80ea7f31__"